var map = {
	"./Black_Account_Icons-01.png": 571,
	"./Black_Account_Icons-02.png": 572,
	"./Black_Account_Icons-03.png": 573,
	"./Black_Account_Icons-04.png": 574,
	"./Black_Account_Icons-05.png": 575,
	"./Black_Account_Icons-06.png": 576,
	"./Black_Account_Icons-07.png": 577,
	"./Black_Account_Icons-08.png": 578,
	"./Black_Account_Icons-09.png": 579,
	"./Black_Account_Icons-10.png": 580,
	"./Black_Account_Icons-11.png": 581,
	"./Black_Account_Icons-12.png": 582,
	"./Black_Account_Icons-13.png": 583,
	"./Black_Account_Icons-14.png": 584,
	"./FilePresentOutlined.svg": 585,
	"./accuracyAccountsDemo_downloadMT4.jpg": 586,
	"./accuracyAccountsReal_downloadMT4.jpg": 587,
	"./alert@2x.svg": 588,
	"./apple-brands.svg": 589,
	"./arrow_up_from_box.svg": 590,
	"./bankWire.svg": 591,
	"./bdswissDemo_downloadMT4.png": 592,
	"./bdswissGlobalDemo_downloadMT4.png": 593,
	"./bdswissGlobalReal02_downloadMT4.png": 594,
	"./bdswissGlobalReal03_downloadMT4.png": 595,
	"./bdswissGlobalReal04_downloadMT4.png": 596,
	"./bdswissGlobalReal05_downloadMT4.png": 597,
	"./bdswissGlobalReal_downloadMT4.png": 598,
	"./bdswissGlobalReal_downloadMT5.png": 599,
	"./bdswissReal02_downloadMT4.png": 600,
	"./bdswissReal03_downloadMT4.png": 601,
	"./bdswissReal04_downloadMT4.png": 602,
	"./bdswissReal05_downloadMT4.png": 603,
	"./bdswissReal_downloadMT4.png": 604,
	"./bdswissReal_downloadMT5.png": 605,
	"./bdswissSCDemo_downloadMT4.png": 606,
	"./bdswissSCReal01_downloadMT4.png": 607,
	"./bdswissSCReal02_downloadMT4.png": 608,
	"./bdswissSCReal03_downloadMT4.png": 609,
	"./bdswissSCReal04_downloadMT4.png": 610,
	"./bdswissSCReal05_downloadMT4.png": 611,
	"./bdswiss_grey.png": 612,
	"./bdswiss_white.png": 613,
	"./bg-image-affiliate.png": 614,
	"./bitwallet-bdSwiss-dark.svg": 615,
	"./bitwallet-bdSwiss-light.svg": 616,
	"./bitwallet-swissMarkets-dark.svg": 617,
	"./bitwallet-swissMarkets-light.svg": 618,
	"./card.svg": 619,
	"./check_circle.png": 620,
	"./chf.png": 621,
	"./competitions.png": 622,
	"./complimentary@2x.svg": 623,
	"./control-radio-off.png": 624,
	"./control-radio-on.png": 625,
	"./crypto.svg": 626,
	"./cvv.svg": 627,
	"./deposit-card.svg": 628,
	"./diners.png": 629,
	"./dkk.png": 630,
	"./document-upload-failure-dark.png": 631,
	"./document-upload-failure-light.png": 632,
	"./document-upload-success-black.png": 633,
	"./document-upload-success-dark.png": 634,
	"./document-upload-success-light.png": 635,
	"./documents-empty-dark.png": 636,
	"./documents-empty-light.png": 637,
	"./downloadPdf-light.png": 638,
	"./downloadPdf.png": 639,
	"./dpWorldTourChampionship-dark.svg": 640,
	"./dpWorldTourChampionship-light.svg": 641,
	"./eWallet.svg": 642,
	"./eur.png": 643,
	"./exp-date.svg": 644,
	"./fees@2x.svg": 645,
	"./filterIcon.png": 646,
	"./gbp.png": 647,
	"./icon-add-account.svg": 363,
	"./icon-appstore@2x.png": 648,
	"./icon-arrow-right-dark.png": 649,
	"./icon-arrow-right-light.png": 650,
	"./icon-bank-wire.svg": 651,
	"./icon-checkbox.svg": 652,
	"./icon-close-dark.svg": 653,
	"./icon-close-light.svg": 654,
	"./icon-close.png": 655,
	"./icon-contact-callback@2x.png": 656,
	"./icon-contact-callback@2x.svg": 657,
	"./icon-contact-chat@2x.png": 364,
	"./icon-contact-chat@2x.svg": 365,
	"./icon-contact-email@2x.png": 658,
	"./icon-contact-email@2x.svg": 659,
	"./icon-contact-faqs@2x.png": 660,
	"./icon-contact-faqs@2x.svg": 661,
	"./icon-contact-oneOnOneSession@2x.png": 662,
	"./icon-contact-telegram@2x.png": 663,
	"./icon-contact-whatsapp@2x.png": 664,
	"./icon-crypto.svg": 665,
	"./icon-document.svg": 666,
	"./icon-facebook@2x.png": 667,
	"./icon-google-play@2x.png": 668,
	"./icon-notification.svg": 669,
	"./icon-profile-big.svg": 670,
	"./icon-profile.svg": 671,
	"./icon-spoa.svg": 672,
	"./icon-swapFree.svg": 673,
	"./icon-telegram@2x.png": 674,
	"./icon-twitter@2x.png": 675,
	"./icon_accounts_dashboard.svg": 676,
	"./icon_logout_dashboard.svg": 677,
	"./icon_notification_dashboard.svg": 678,
	"./icon_profilesettings_dashboard.svg": 679,
	"./icon_support_dashboard.svg": 680,
	"./icon_transaction_dashboard.svg": 681,
	"./jcb.png": 682,
	"./languages.png": 683,
	"./limit-failure-dark.png": 684,
	"./limit-failure-light.png": 685,
	"./logo-accuracy.png": 686,
	"./logo-bdstrading-white.svg": 687,
	"./logo-bdstrading.svg": 688,
	"./logo-bdswiss-white.svg": 689,
	"./logo-bdswiss.png": 690,
	"./logo-bdswiss.svg": 691,
	"./logo-equityflow-black.png": 692,
	"./logo-equityflow-white.png": 693,
	"./logo-facebook.png": 694,
	"./logo-google.png": 695,
	"./logo-lydian-black.png": 696,
	"./logo-lydian-black.svg": 697,
	"./logo-lydian-white.svg": 698,
	"./logo-regalx-white.png": 699,
	"./logo-regalx.png": 700,
	"./logo-skyground-black.svg": 701,
	"./logo-skyground-white.svg": 702,
	"./logo-swissmarkets-white.svg": 703,
	"./logo-swissmarkets.png": 704,
	"./logo-swissmarkets.svg": 705,
	"./logo-tauromarkets-black.png": 706,
	"./logo-tauromarkets-white.png": 707,
	"./logo-tauromarkets-white2.png": 708,
	"./logo-tauromarkets-white2.svg": 709,
	"./logo-valutamarkets.png": 710,
	"./maestro.png": 711,
	"./mastercard.png": 712,
	"./mastercard_logo_icon.svg": 713,
	"./mercedesCup-dark.svg": 714,
	"./mercedesCup-light.svg": 715,
	"./nationalIdBR.png": 716,
	"./nationalIdES.jpg": 717,
	"./nationalIdIT.jpg": 718,
	"./nationalIdZA.png": 719,
	"./no-trades-dark.png": 720,
	"./no-trades-light.png": 721,
	"./no-trading-signals-dark.png": 722,
	"./nok.png": 723,
	"./notifications-empty-dark.png": 724,
	"./notifications-empty-light.png": 725,
	"./onlineBanking.svg": 726,
	"./onlineDeposit.svg": 727,
	"./page-not-found-dark.svg": 366,
	"./page-not-found-light.svg": 367,
	"./payment-failure-dark.png": 728,
	"./payment-failure-light.png": 729,
	"./payment-pending-dark.png": 730,
	"./payment-pending-light.png": 731,
	"./payment-success-dark.png": 732,
	"./payment-success-light.png": 733,
	"./payments-history-empty-dark.png": 734,
	"./payments-history-empty-light.png": 735,
	"./phone_verification.png": 736,
	"./place1-leadership.png": 737,
	"./place2-leadership.png": 738,
	"./place3-leadership.png": 739,
	"./pln.png": 740,
	"./pof-bankStatement.png": 741,
	"./pof-bankStatementPOF.png": 742,
	"./pof-card-back.png": 743,
	"./pof-card.png": 744,
	"./pof-cardStatement.png": 745,
	"./pof-other.png": 746,
	"./pof-proofOfResidence.png": 747,
	"./pof-swiftCopyPaymentAdvice.png": 748,
	"./pof-virtualCard.png": 749,
	"./poi-document.png": 750,
	"./poi-drivingLicense-back.png": 751,
	"./poi-drivingLicense.png": 752,
	"./poi-id-back.png": 753,
	"./poi-id.png": 754,
	"./poi-passport.png": 755,
	"./por-bankStatementPOR.png": 756,
	"./por-document.png": 757,
	"./por-proofOfResidence.png": 758,
	"./por-utilityBill.png": 759,
	"./priority@2x.svg": 760,
	"./referAndEarn.png": 761,
	"./regalxDemo_downloadMT4.png": 762,
	"./regalxReal01_downloadMT4.png": 763,
	"./regalxReal02_downloadMT4.png": 764,
	"./regalxReal03_downloadMT4.png": 765,
	"./regalxReal04_downloadMT4.png": 766,
	"./regalxReal05_downloadMT4.png": 767,
	"./register-referral-light.png": 768,
	"./sek.png": 769,
	"./sign-up.png": 770,
	"./spaceship.png": 771,
	"./spreads@2x.svg": 772,
	"./support@2x.svg": 773,
	"./swissmarketsDemo_downloadMT4.png": 774,
	"./swissmarketsReal02_downloadMT4.png": 775,
	"./swissmarketsReal_downloadMT4.png": 776,
	"./tauroDemo01DownloadMT4.jpg": 777,
	"./tauroReal01DownloadMT4.jpg": 778,
	"./technicalIndicator-ebook.png": 779,
	"./technicalIndicatorItem.svg": 780,
	"./telegram-dark.png": 781,
	"./telegram.png": 782,
	"./trading-alerts-tradingAlerts-dark.png": 783,
	"./trading-alerts-tradingAlerts-light.png": 784,
	"./tradingPsychology-ebook.png": 785,
	"./tradingPsychologyItem.svg": 786,
	"./transfer-external.svg": 787,
	"./transfer-internal.svg": 788,
	"./transfer-spoa.svg": 789,
	"./upload-bankStatement-error.png": 790,
	"./upload-bankStatement-success.png": 791,
	"./upload-bankStatement.png": 792,
	"./upload-document-dark.png": 793,
	"./upload-document-light.png": 794,
	"./upload-generic-error.png": 795,
	"./upload-generic-success.png": 796,
	"./upload-generic.png": 797,
	"./upload-pof-back-card-error.png": 798,
	"./upload-pof-back-card-success.png": 799,
	"./upload-pof-back-card.png": 800,
	"./upload-pof-front-card-error.png": 801,
	"./upload-pof-front-card-success.png": 802,
	"./upload-pof-front-card.png": 803,
	"./upload-poi-back-drivingLicense-error.png": 804,
	"./upload-poi-back-drivingLicense-success.png": 805,
	"./upload-poi-back-drivingLicense.png": 806,
	"./upload-poi-back-error.png": 807,
	"./upload-poi-back-success.png": 808,
	"./upload-poi-back.png": 809,
	"./upload-poi-front-drivingLicense-error.png": 810,
	"./upload-poi-front-drivingLicense-success.png": 811,
	"./upload-poi-front-drivingLicense.png": 812,
	"./upload-poi-front-error.png": 813,
	"./upload-poi-front-success.png": 814,
	"./upload-poi-front.png": 815,
	"./upload-por-front-error.png": 816,
	"./upload-por-front-proofOfResidence-error.png": 817,
	"./upload-por-front-proofOfResidence-success.png": 818,
	"./upload-por-front-proofOfResidence.png": 819,
	"./upload-por-front-success.png": 820,
	"./upload-por-front-utilityBill-error.png": 821,
	"./upload-por-front-utilityBill-success.png": 822,
	"./upload-por-front-utilityBill.png": 823,
	"./upload-por-front.png": 824,
	"./usd.png": 825,
	"./visa.png": 826,
	"./visa_logo_icon.svg": 827,
	"./vps-enter-credentials.png": 828,
	"./vps-remote-desktop-windows.png": 829,
	"./vps-remote-desktop.png": 830,
	"./waiting-list-skip-dark.png": 831,
	"./waiting-list-skip.png": 832,
	"./windows-brands.svg": 833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1211;